"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const avatar_button_style_1 = __importDefault(require("./avatar.button.style"));
const avatar_1 = __importDefault(require("./avatar"));
const avatar_overlay_1 = __importDefault(require("./avatar.overlay"));
const icons_1 = require("../../icons");
class AvatarButton extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.handleClick = event => {
            if (!this.props.disabled)
                this.props.onClick(event);
        };
        this.render = () => {
            const { classes, label, src, disabled, buttonRef: ref, size, overlay } = this.props;
            const rootProps = {
                className: classes.root,
                onClick: this.handleClick,
                type: 'button',
                style: {
                    height: size,
                    width: size
                },
                disabled,
                ref,
                'aria-label': label
            };
            return (jsx_runtime_1.jsxs("button", Object.assign({}, rootProps, { children: [jsx_runtime_1.jsx(avatar_1.default, { src: src, border: true }, void 0),
                    overlay && jsx_runtime_1.jsx(avatar_overlay_1.default, { icon: jsx_runtime_1.jsx(icons_1.icons.Upload, {}, void 0) }, void 0)] }), void 0));
        };
    }
}
exports.AvatarButton = AvatarButton;
AvatarButton.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    label: prop_types_1.default.string,
    src: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    buttonRef: prop_types_1.default.func,
    size: prop_types_1.default.number,
    overlay: prop_types_1.default.bool
};
AvatarButton.defaultProps = {
    label: null,
    src: null,
    disabled: false,
    buttonRef: () => { },
    size: null,
    overlay: false
};
exports.default = react_jss_1.default(avatar_button_style_1.default)(AvatarButton);
//# sourceMappingURL=avatar.button.js.map